module.exports = __webpack_public_path__ + "fonts/Artifakt-Element-Hair.0acb5663.woff";